import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getSelectedItems, togglePlatform, trySearchFocusItemSection} from "../../../redux/slices/dynamicUiSlice";
import ComponentLoader, {ComponentError, ComponentNoData} from "../../../components/ComponentLoader";
import AddToSelectedModal from "../dynamic_items/AddToSelectedModal";
import UIHeader from "./UIHeader";
import SelectedMoveActions from "./SelectedMoveActions";
import DynamicSelectedItem from "./DynamicSelectedItem";
import {debounce} from "lodash";
import {PLATFORM_MOBILE, PLATFORM_WEB} from "../../../constants/commons";
import {getSelectedDataByPlatform} from "../dynamicUiFunctions";

const DynamicContents = ({}) => {
  const dispatch = useDispatch();

  const selectedPage = useSelector((state) => (state.dynamicUi.pages.selectedPage));
  const selectedGroup = useSelector((state) => (state.dynamicUi.pages.selectedGroup));



  // const {loading, data, init, error} = useSelector((state) => state.dynamicUi.selected);
  const {
    loading = false,
    data = [],
    init = false,
    error = ""
  } = useSelector((state) => state.dynamicUi.selected[selectedPage]) ?? {};

  const {data: pages, loading: pagesLoading, init: pageInit} = useSelector((state) => (state.dynamicUi.pages[selectedGroup]));



  const isPlatformMobile = useSelector((state) => state.dynamicUi.isPlatformMobile);
  const {loading: itemsLoading, error: itemsError} = useSelector((state) => state.dynamicUi.items);
  const [itemToUpdate, setItemToUpdate] = useState(undefined);
  const [displayMenu, setDisplayMenu] = useState(false);


  const hasPages = pageInit && Object.values(pages).length;


  useEffect(() => {
    if (!init && !loading && !error && selectedPage)
      dispatch(getSelectedItems());
  }, [selectedPage, init, loading, error]);

  // noinspection JSCheckFunctionSignatures
  const debouncedToggleView = useCallback(
    debounce(() => {
      dispatch(togglePlatform());
    }, 200),
    [dispatch, isPlatformMobile]
  );

  // const platformWiseSelectedData2 = data.filter((datum) => datum?.section?.platform === PLATFORM_BOTH || datum?.section?.platform === (isPlatformMobile ? PLATFORM_MOBILE : PLATFORM_WEB));
  const platformWiseSelectedData = getSelectedDataByPlatform(data, isPlatformMobile ? PLATFORM_MOBILE : PLATFORM_WEB);

  return (
    <div className={`w-full flex items-center flex-col relative ${isPlatformMobile ? 'mobile' : 'web'}`}>
      <SelectedMoveActions displayMenu={displayMenu} setDisplayMenu={setDisplayMenu} toggleUiView={debouncedToggleView}
                           mobileView={isPlatformMobile} deleteButton={pages[selectedPage]?.deletable} pageTabButton={true}
                           loading={loading || !!error || itemsLoading || !!itemsError || !init || pagesLoading || !hasPages} editButton={true} />
      <div className="ui-width dynamic-ui mt-4 bg-background pb-3">
        <UIHeader/>
        {error ?
          <ComponentError className="image-aspect-ratio mt-2" errorMsg={error}
                          retry={() => dispatch(getSelectedItems())}/>
          : loading || pagesLoading|| !init ?
            Array.from({length: 5}, (v, index) =>
              <ComponentLoader className="image-aspect-ratio mt-2" key={`selected-loaders-${index}`}/>)

            : (init && !platformWiseSelectedData.length) || !hasPages ?
              <ComponentNoData msg="No data" className="image-aspect-ratio mt-2"/> :
              <>
                {platformWiseSelectedData.map((item, pos) =>
                  <DynamicSelectedItem item={item} key={`selected-item-${item.id}`} isFirst={pos === 0}
                                       mobile={isPlatformMobile}
                                       isLast={pos === platformWiseSelectedData.length - 1}
                                       onMoveDown={() => setItemToUpdate({
                                         ...item,
                                         position: pos + 1,
                                         disabled: pos,
                                         pr: 1
                                       })}
                                       onMoveUp={() => setItemToUpdate({
                                         ...item,
                                         position: pos - 1,
                                         disabled: pos,
                                         pr: 0
                                       })}
                                       onDelete={() => setItemToUpdate({
                                         ...item.section,
                                         remove: true,
                                         sectionId: item.id
                                       })}
                                       onSearch={() => dispatch(trySearchFocusItemSection(item.section_id))}
                                       showActions={displayMenu}

                  />)}
              </>}
        <AddToSelectedModal showModal={itemToUpdate} setShowModal={() => {
          setItemToUpdate(undefined);
        }}/>
      </div>
    </div>
  );
};

export default React.memo(DynamicContents);
